import { render, staticRenderFns } from "./StudyPdf.vue?vue&type=template&id=920e46c8&"
import script from "./studypdf.js?vue&type=script&lang=js&"
export * from "./studypdf.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports